"use client";

import { useEffect, useState, type ReactNode } from "react";
import { CONSENT_EVENT, readConsent } from "../../library/cookie-consent";

export default function ConsentGate({ category, children }: {
  category: "analytics" | "marketing";
  children: ReactNode;
}) {
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    const sync = () => setAllowed(readConsent()?.[category] === true);
    sync();
    window.addEventListener(CONSENT_EVENT, sync);
    return () => window.removeEventListener(CONSENT_EVENT, sync);
  }, [category]);
  return allowed ? children : null;
}
